import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getClaimCategories} from "../services/ClaimCategoryService";
import {useLogout} from "./useLogout";

export function useClaimCategories({enabled = true} = {}) {
    const [claimCategories, setClaimCategories] = useState([]);

    const logout = useLogout();
    const {data, isError, error, refetch, isFetching} = useQuery({
        queryKey: ["claimCategories"],
        queryFn: getClaimCategories,
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setClaimCategories(data);
        }
    }, [data]);

    return [claimCategories, refetch, isFetching];
}
